import script from "./NoticeDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeDetailView.vue?vue&type=style&index=0&id=194c2d0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194c2d0a"]])

export default __exports__